<template>
  <article class="page-item">

    <lc-audio
      :audio="audio"
      :key="audio.id"
      v-for="audio in page.audios"
    />

    <header class="content-header container-sm">
      <span class="content-position">
        <span class="content-position__label">
          {{ $t('viewer.content.header.label', { count: pageNumber }) }}
        </span>
      </span>
    </header>

    <content-viewer :page="page" :content="page.content" />
  </article>
</template>

<script>
import { mapGetters } from 'vuex';

import ContentViewer from '../components/ContentViewer';
import LcAudio from '../components/LcAudio';

export default {
  name: 'page-item',

  props: [
    'page',
  ],

  components: {
    ContentViewer,
    LcAudio,
  },

  computed: {
    ...mapGetters({
      pageNumber: 'getPageNumber',
    }),
  },

};
</script>

<style lang="scss" scoped>
  .content-header {
    padding-top: 28px;
    padding-bottom: 8px;
  }

  .content-position {
    .content-position__label {
      font-weight: bold;
      font-size: 14px;
      color: rgba(0, 0, 0, 0.54);
    }
  }
</style>
